import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restaurantstyle1',
  templateUrl: './restaurantstyle1.component.html',
  styleUrls: ['./restaurantstyle1.component.css']
})
export class Restaurantstyle1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
